// Translates text between some supported languages + other language utilities
angular
	.module('translator')
	.factory('tgTranslate', function tgTranslateFactory($translate, $http, tgConfig, tgIdentity) {
		var supportedLanguages, currentLanguage

		return {
			setSupportedLanguages: function (langs) {
				supportedLanguages = langs
			},
			getSupportedLanguages: function () {
				return supportedLanguages
			},
			getLanguageName: function (code) {
				var lang = _.find(supportedLanguages, { code: code })
				return lang ? (lang.name ? lang.name : code) : 'not supported'
			},
			preferredLanguage: $translate.preferredLanguage,
			use: function (lang) {
				currentLanguage = lang
				return $translate.use(lang)
			},
			getCurrentLanguage: function () {
				return currentLanguage
			},
			instant: $translate.instant,
			autoTranslate: function (data, successCallback, errorCallback) {
				$http({
					method: 'POST',
					url: tgConfig.tagmeApi.gatewayHost + '/Translate',
					data: data,
					headers: { apitoken: tgConfig.tagmeApi.token, authtoken: tgIdentity.currentUser.authtoken }
				})
					.success(function (data, status, headers, config) {
						;(successCallback || angular.noop)(data, status, headers, config)
					})
					.error(function (data, status, headers, config) {
						;(errorCallback || angular.noop)(data, status, headers, config)
					})
			},
		}
	})
